export enum Motivation {
  Unknown = 'Unknown',
  AttackOrDestruction = 'AttackOrDestruction',
  Espionage = 'Espionage',
  FinancialGain = 'FinancialGain',
  Hacktivism = 'Hacktivism',
  Influence = 'Influence',
  Notoriety = 'Notoriety',
  Nuisance = 'Nuisance',
  Surveillance = 'Surveillance',
  Opportunistic = 'Opportunistic',
}

export const MotivationDescriptor = Object.freeze({
  [Motivation.Unknown]: 'Unknown',
  [Motivation.AttackOrDestruction]: 'Attack / Destruction',
  [Motivation.Espionage]: 'Espionage',
  [Motivation.FinancialGain]: 'Financial Gain',
  [Motivation.Hacktivism]: 'Hacktivism',
  [Motivation.Influence]: 'Influence',
  [Motivation.Notoriety]: 'Notoriety',
  [Motivation.Nuisance]: 'Nuisance',
  [Motivation.Surveillance]: 'Surveillance',
  [Motivation.Opportunistic]: 'Opportunistic',
});

export const MotivationTooltips = Object.freeze({
  [Motivation.Unknown]:
    'The motivation behind the attack could not be determined from public sources.No specific intent has been identified.',
  [Motivation.AttackOrDestruction]:
    'The goal is to damage, disrupt, or destroy systems, data, or infrastructure—often through malware, ransomware, or sabotage.',
  [Motivation.Espionage]:
    'The attacker seeks to collect confidential or strategic information, usually for government or corporate intelligence purposes.',
  [Motivation.FinancialGain]:
    'The motivation is profit, such as stealing data to sell, committing fraud, or demanding ransom payments.',
  [Motivation.Hacktivism]:
    'Attacks driven by political or ideological beliefs, aiming to protest, expose, or raise awareness about certain issues.',
  [Motivation.Influence]:
    'The objective is to manipulate public opinion or decision-making, often through disinformation or propaganda campaigns.',
  [Motivation.Notoriety]:
    'The attacker wants fame or recognition, often by performing high-profile or technically impressive attacks.',
  [Motivation.Nuisance]:
    'The intent is to annoy, disrupt, or inconvenience others without a strategic or financial goal—often low-skill or random.',
  [Motivation.Surveillance]:
    'The attacker aims to monitor individuals or organizations, often for intelligence gathering or control.',
  [Motivation.Opportunistic]:
    'The attack happens simply because a vulnerability is available, without a specific target or long-term plan.',
});
